import React, { Component } from 'react';
import { Form, Segment, Dropdown, Divider } from 'semantic-ui-react';
import { state } from '../../utils/defaults';
class AddGuarantor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: 'React'
        };
    }

    render() {
        return (
            <Segment tertiary>
                <Form.Group>
                    <Form.Field width={4} className="required">
                        <label>{this.props.t("lastname")}:</label>
                        <Form.Input name="acsConsumerLastName" value={this.props._ifNull(this.props.inputs.acsConsumerLastName, "")} onChange={this.props.handleChange} placeholder={this.props.t("max50")} type="text" maxLength={50} />
                        {this.props.validator.message('Last Name' + this.props.unique, this.props.inputs.acsConsumerLastName, 'required', false, { default: 'The Last Name field is required.' })}
                    </Form.Field>
                    <Form.Field width={4} className={this.props.isBusiness ? "" : "required"}>
                        <label>{this.props.t("firstname")}:</label>
                        <Form.Input name="acsConsumerFirstName" value={this.props._ifNull(this.props.inputs.acsConsumerFirstName, "")} onChange={this.props.handleChange} placeholder="Max 50 Characters" type="text" maxLength={50} />
                        {this.props.validator.message('First Name' + this.props.unique, this.props.inputs.acsConsumerFirstName, 'valueBasedrequired:' + this.props.isBusiness + ',' + this.props.inputs.acsConsumerFirstName, false, { default: 'The Last Name field is required.' })}
                    </Form.Field>
                    <Form.Field width={4}>
                        <label>Middle Name:</label>
                        <Form.Input name="acsConsumerMiddleName" value={this.props._ifNull(this.props.inputs.acsConsumerMiddleName, "")} onChange={this.props.handleChange} placeholder="Max 50 Characters" type="text" maxLength={50} />
                    </Form.Field>
                    <Form.Field width={4}>
                        <label>{this.props.t("ssn")}:</label>
                        <Form.Input name="acsConsumerSsn" value={this.props._ifNull(this.props.inputs.acsConsumerSsn, "")} onChange={this.props.handleChange} placeholder="000000000" type="text" maxLength="9" />
                        {this.props.validator.message('SSN' + this.props.unique, this.props.inputs.acsConsumerSsn, 'min:9|integer|max:9', false, { default: 'The SSN must be an integer.' })}
                    </Form.Field>
                </Form.Group>
                <Form.Group>
                    <Form.Field width={4}>
                        <label>DOB:</label>
                        <Form.Input name="acsConsumerDob" value={this.props._ifNull(this.props.inputs.acsConsumerDob, "")} onChange={this.props.handleChange} placeholder="00/00/0000" type="date" />
                    </Form.Field>
                    <Form.Field width={4}>
                        <label>License Number:</label>
                        <Form.Input name="acsConsumerDrivingLicense" value={this.props._ifNull(this.props.inputs.acsConsumerDrivingLicense, "")} onChange={this.props.handleChange} placeholder="0000000000000" type="text" maxLength="50" />
                    </Form.Field>
                    <Form.Field width={4}>
                        <label>Phone:</label>
                        <Form.Input name="acsPhone" value={this.props._ifNull(this.props.inputs.acsPhone, "")} onChange={this.props.handleChange} placeholder="0000000000" type="text" maxLength="10" />
                        {this.props.validator.message('Phone' + this.props.unique, this.props.inputs.acsPhone, 'phone')}
                    </Form.Field>
                    <Form.Field width={4}>
                        <label>Alt Phone:</label>
                        <Form.Input name="acsAltPhone" value={this.props._ifNull(this.props.inputs.acsAltPhone, "")} onChange={this.props.handleChange} placeholder="0000000000" type="text" maxLength="10" />
                        {this.props.validator.message('Alt Phone' + this.props.unique, this.props.inputs.acsAltPhone, 'phone')}
                    </Form.Field>
                </Form.Group>
                <Form.Group>
                    <Form.Field width={12} className="required">
                        <label>{this.props.t("address.street")}:</label>
                        <Form.Input name="acsConsumerAddress1" value={this.props._ifNull(this.props.inputs.acsConsumerAddress1, "")} onChange={this.props.handleChange} placeholder={this.props.t("address.street")} type="text" />
                        {this.props.validator.message(this.props.t("address.street") + this.props.unique, this.props.inputs.acsConsumerAddress1, 'required', false, { default: 'The Address (Street) field is required.' })}
                    </Form.Field>
                    <Form.Field width={4}>
                        <label>Apt / Suite Number:</label>
                        <Form.Input name="acsConsumerAddressSuite" value={this.props._ifNull(this.props.inputs.acsConsumerAddressSuite, "")} onChange={this.props.handleChange} placeholder="Apt / Suite Number" type="text" />
                    </Form.Field>
                </Form.Group>
                <Form.Group>
                    <Form.Field width={6}>
                        <label>Address (PO Box):</label>
                        <Form.Input name="acsConsumerAddress2" value={this.props._ifNull(this.props.inputs.acsConsumerAddress2, "")} onChange={this.props.handleChange} placeholder="PO Box Address" type="text" />
                    </Form.Field>
                    <Form.Field width={2} className="required">
                        <label>{this.props.t("zipcode")}:</label>
                        <Form.Input name="acsPostalCode" value={this.props._ifNull(this.props.inputs.acsPostalCode, "")} onChange={this.props.handleChange} placeholder={this.props.t("zipcode")} type="text" maxLength="9" />
                        {this.props.validator.message(this.props.t("zipcode") + this.props.unique, this.props.inputs.acsPostalCode, 'required|max:9|numeric', false, { default: 'The Zip code must be a number' })}
                    </Form.Field>
                    <Form.Field width={4} className="required">
                        <label>{this.props.t("city")}:</label>
                        <Form.Input name="acsLocality" value={this.props._ifNull(this.props.inputs.acsLocality, "")} onChange={this.props.handleChange} placeholder="City" type="text" />
                        {this.props.validator.message(this.props.t("city") + this.props.unique, this.props.inputs.acsLocality, 'required', false, { default: 'The ' + this.props.t("city") + ' field is required.' })}
                    </Form.Field>
                    <Form.Field width={4} className="required">
                        <label>{this.props.t("state")}:</label>
                        <Dropdown name="acsRegion" value={this.props._ifNull(this.props.inputs.acsRegion, "")} onChange={this.props.handleChange} placeholder='Select' className="fluid" search selection options={state}></Dropdown>
                        {this.props.validator.message(this.props.t("state") + this.props.unique, this.props.inputs.acsRegion, 'required', false, { default: 'The ' + this.props.t("state") + ' field is required.' })}
                    </Form.Field>
                </Form.Group>
                <Divider />
                <Form.Group>
                    <Form.Field width={6}>
                        <label>Employer Name:</label>
                        <Form.Input name="acsEmployerName" value={this.props._ifNull(this.props.inputs.acsEmployerName, "")} onChange={this.props.handleChange} placeholder="Employer Name" type="text" />
                    </Form.Field>
                    <Form.Field width={6}>
                        <label>Employer Phone:</label>
                        <Form.Input name="acsEmployerPhone" value={this.props._ifNull(this.props.inputs.acsEmployerPhone, "")} onChange={this.props.handleChange} placeholder="Employer Phone" type="text" maxLength="10" />
                        {this.props.validator.message('Phone' + this.props.unique, this.props.inputs.acsEmployerPhone, 'phone', false, { default: 'The phone number must a Valid phone number' })}
                    </Form.Field>
                    <Form.Field width={4}>
                    </Form.Field>
                </Form.Group>
                <Form.Group>
                    <Form.Field width={6}>
                        <label>Employer Address:</label>
                        <Form.Input name="acsEmployerAddress" value={this.props._ifNull(this.props.inputs.acsEmployerAddress, "")} onChange={this.props.handleChange} placeholder="Employer Address" type="text" />
                    </Form.Field>
                    <Form.Field width={2}>
                        <label>Employer Zip Code:</label>
                        <Form.Input name="acsEmployerPostalCode" value={this.props._ifNull(this.props.inputs.acsEmployerPostalCode, "")} onChange={this.props.handleChange} placeholder={this.props.t("zipcode")} type="text" maxLength="9" />
                        {this.props.validator.message(this.props.t("zipcode") + this.props.unique, this.props.inputs.acsEmployerPostalCode, 'max:9|numeric', false, { default: 'The Zip code must be a number' })}
                    </Form.Field>
                    <Form.Field width={4}>
                        <label>Employer City:</label>
                        <Form.Input name="acsEmployerLocality" value={this.props._ifNull(this.props.inputs.acsEmployerLocality, "")} onChange={this.props.handleChange} placeholder="City" type="text" />
                    </Form.Field>
                    <Form.Field width={4}>
                        <label>Employer State:</label>
                        <Dropdown name="acsEmployerRegion" value={this.props._ifNull(this.props.inputs.acsEmployerRegion, "")} onChange={this.props.handleChange} placeholder='Select' className="fluid" search selection options={state}></Dropdown>
                    </Form.Field>
                </Form.Group>
            </Segment>
        );
    }
}
export default AddGuarantor;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/AddGuarantor.js